
import Swal from "sweetalert2";
import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import Navbar from "../../../components/Navbar.js";
import Select from "react-select";
import Switch from "react-switch";
import LOGO from "../../../assets/images/logo.png";
import SignatureCanvas from 'react-signature-canvas';
import {
    locale,
    tokens,
    select_style,
    required,
    // alert
    success,
    success_url,
    alert,
    alert_url,
    // function
    logout,
    number_zero,
    format_date,
    toFixed,
    total,
    validate,
    random_charactor,
    float,
    // api
    GET,
    POST,
    PUT,
    DELETE,
    error_message,
    // storage
    removeStorage,
    getStorage,

    validate_email,
    validate_th,
    validate_en,
    validate_en_number,

    LinktoBase64,
    // component
    DatePicker,
} from "../../../components/CustomComponent.js";

import "../../../components/global.js";
import "../../../assets/css/bootstrap.css";
import "../../../assets/css/index.css";

export default class Dashboard extends Component {
    constructor(props) {
        super(props)
        this.state = {
            modal_create: false,
            modal_delete: false,
            modal_update: false,


            loading: false,
            data_supplier: [],
            data_product: [],

            stock_item_list: [],

            po_main_id: "",
            po_main_number: "",
            company_id: "",
            tax_number: "",
            address: "",

            product_code: "",
            quantity: "",
            price_by_item: "",

            discount: "",
            remark: "",
            is_vat: false,

            decision_status: "0"
        }
    }
    async componentDidMount() {
        this.setState({ loading: true });
        await this.GetSupplier();
        await this.getProductAll();
        if (this.props.location.query.id) {
            this.GetById(this.props.location.query.id)
        }
        this.setState({ loading: false });
    }

    GetById = async (id) => {
        let body = {
            page: "",
            data_search: "",
            po_main_id: id
        }
        let result = await GET(tokens, "v1/TH/purchase-order/list/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            console.log(result);
            this.setState({
                po_main_id: id,
                po_main_number: result.data.po_main_number,
                company_id: result.data.relation_company_supplier ? this.state.data_supplier.filter(item => item.value === result.data.relation_company_supplier.company_id)[0] : "",
                tax_number: result.data.tax_number ? result.data.tax_number : result.data.relation_company_supplier.tax_number,
                address: result.data.relation_company_supplier ? this.state.data_supplier.filter(item => item.value === result.data.relation_company_supplier.company_id)[0].address : "",

                discount: result.data.discount,
                is_vat: result.data.vat !== 0 ? true : false,
                remark: result.data.remark,

                decision_status: result.data.decision_status.toString(),
                stock_item_list: result.data.po_list_data.map(item => {
                    return {
                        product_code: item.relation_product_main.product_code ? this.state.data_product.filter(e => e.value === item.relation_product_main.product_code)[0] : "",
                        quantity: item.quantity,
                        price_by_item: item.price_by_item,
                        total_price_by_item: item.total_price_by_item
                    }
                })
            })
            // this.setState({ data: result });
        }
    }
    GetSupplier = async () => {
        let body = {
            page: 0,
            data_search: "",
            company_type: 2,
            company_id: ""
        }
        let result = await GET(tokens, "v1/TH/company-info/list/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            console.log(result);
            this.setState({ data_supplier: result.data.map(e => { return { value: e.company_id, label: e.company_name, tax_number: e.tax_number, address: e.address } }) });
        }
    }
    getProductAll = async () => {
        let body = {
            page: 0,
            data_search: "",
            product_code: ""
        }
        let result = await GET(tokens, "v1/TH/product-manage/product/list/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            console.log(result);
            this.setState({ data_product: result.data.filter(e => e.product_type === "อะไหล่").map(e => { return { value: e.product_code, label: e.product_name, ...e } }) });
        }
    }

    Create = async () => {
        this.setState({ loading: true });
        let data = {
            company_id: this.state.company_id ? this.state.company_id.value : "",
            discount: Number(this.state.discount),
            address: this.state.address,
            office_number: "",
            tax_number: this.state.tax_number,
            remark: this.state.remark,
            total_price: Number(total(this.state.stock_item_list, "total_price_by_item")),
            vat: this.state.is_vat ? Number(toFixed((total(this.state.stock_item_list, "total_price_by_item") - Number(this.state.discount)) * 0.07).replaceAll(",", "")) : 0,
            total_price_final: Number(total(this.state.stock_item_list, "total_price_by_item") - Number(this.state.discount) + Number(this.state.is_vat ? Number(toFixed((total(this.state.stock_item_list, "total_price_by_item") - Number(this.state.discount)) * 0.07).replaceAll(",", "")) : 0)),
            decision_remark: "",
            decision_status: 0,
            receive_date: format_date(new Date(), "dd/mm/yyyy", "en"),
            credit_day: 0,
            due_date: format_date(new Date(), "dd/mm/yyyy", "en"),
            stock_item_list: this.state.stock_item_list.map(item => {
                return {
                    product_code: item.product_code ? item.product_code.value : "",
                    price_by_item: Number(item.price_by_item),
                    quantity: Number(item.quantity),
                    total_price_by_item: Number(item.total_price_by_item),
                }
            }),
        }
        let result = await POST(tokens, "v1/TH/purchase-order/create/" + getStorage("branch").branch_id, data);
        if (result && result.status) {
            success_url("/order/list-order");
        }
        this.setState({ loading: false });
    }
    Update = async () => {
        this.setState({ loading: true });
        let data = {
            po_main_id: this.state.po_main_id,
            company_id: this.state.company_id ? this.state.company_id.value : "",
            discount: Number(this.state.discount),
            address: this.state.address,
            office_number: "",
            tax_number: this.state.tax_number,
            remark: this.state.remark,
            total_price: Number(total(this.state.stock_item_list, "total_price_by_item")),
            vat: this.state.is_vat ? Number(toFixed((total(this.state.stock_item_list, "total_price_by_item") - Number(this.state.discount)) * 0.07).replaceAll(",", "")) : 0,
            total_price_final: Number(total(this.state.stock_item_list, "total_price_by_item") - Number(this.state.discount) + Number(this.state.is_vat ? Number(toFixed((total(this.state.stock_item_list, "total_price_by_item") - Number(this.state.discount)) * 0.07).replaceAll(",", "")) : 0)),
            decision_remark: "",
            decision_status: Number(this.state.decision_status),
            receive_date: format_date(new Date(), "dd/mm/yyyy", "en"),
            credit_day: 0,
            due_date: format_date(new Date(), "dd/mm/yyyy", "en"),
            stock_item_list: this.state.stock_item_list.map(item => {
                return {
                    product_code: item.product_code ? item.product_code.value : "",
                    price_by_item: Number(item.price_by_item),
                    quantity: Number(item.quantity),
                    total_price_by_item: Number(item.total_price_by_item),
                }
            }),
        }
        let result = await PUT(tokens, "v1/TH/purchase-order/update", data);
        if (result && result.status) {
            success_url("/order/list-order");
        }
        this.setState({ loading: false });
    }
    render() {
        return (
            <div className="w-100 min-vh-100 fade-in">
                {this.state.loading && (<div className="spinner-container"> <div className="loading-spinner"></div> </div>)}
                <Navbar page1="หน้าหลัก" page2="แดชบอร์ด" />
                {/* BODY */}
                <div className="body bg-light min-vh-100">
                    <div className="p-3">
                        {/* หัวข้อ และ ปุ่มเพิ่ม */}
                        <div className="d-flex mx-0 align-items-center justify-content-between test mb-2 flex-wrap">
                            <h3 className="mb-2"><b>สร้างใบสั่งซื้อ {this.state.po_main_number} : </b><b className="text-orange">รออนุมัติ</b></h3>
                            <button className="btn btn-outline-orange mx-1" onClick={() => { window.location.href = "/order/list-order" }}>
                                <span className="icon me-2">{"\uf060"}</span>ย้อนกลับ
                            </button>
                        </div>
                        <div className="row">
                            <div className="col-12 col-lg-5 mb-2">
                                <div className="w-100 card border-0 p-3 rounded-lg">
                                    <div className="row mb-2">
                                        <div className="col-12 col-md-6">
                                            <label className="mb-2">ชื่อบริษัท:</label>
                                            <Select
                                                className="form-control select-search"
                                                styles={select_style}
                                                options={this.state.data_supplier}
                                                onChange={(e) => {
                                                    this.setState({ company_id: e });
                                                    if (e) {
                                                        this.setState({ tax_number: e.tax_number, address: e.address })
                                                    } else {
                                                        this.setState({ tax_number: "", address: "" })
                                                    }
                                                }}
                                                value={this.state.company_id}
                                                isClearable
                                            ></Select>
                                        </div>
                                        <div className="col-12 col-md-6">
                                            <label className="mb-2">เลขที่ผู้เสียภาษี:</label>
                                            <input
                                                className="form-control mb-2"
                                                type="text"
                                                placeholder=""
                                                onChange={(e) => { this.setState({ tax_number: e.target.value }) }}
                                                value={this.state.tax_number}
                                                readOnly
                                            />
                                        </div>
                                        <div className="col-12">
                                            <label className="mb-2">ที่อยู่:</label>
                                            <textarea
                                                className="form-control mb-2"
                                                placeholder=""
                                                onChange={(e) => { this.setState({ address: e.target.value }) }}
                                                value={this.state.address}
                                                rows={5}
                                                readOnly
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-lg-7">
                                <div className="w-100 card border-0 p-0 rounded-lg" style={{ height: "100%" }}>
                                    <div>
                                        <table className="table table-borderless table-striped">
                                            <thead className="bg-primary">
                                                <tr>
                                                    <th className="text-center text-white wpx-70">ลำดับ</th>
                                                    <th className="text-left text-white">ชื่อสินค้า</th>
                                                    <th className="text-center text-white wpx-80">จำนวน</th>
                                                    <th className="text-end text-white wpx-90">ราคา/หน่วย</th>
                                                    <th className="text-end text-white wpx-90">ราคา</th>
                                                    <th className="text-center text-white wpx-70">จัดการ</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.stock_item_list.map((item, index) => (
                                                    <tr>
                                                        <td className="text-center">{index + 1}</td>
                                                        <td>
                                                            <Select
                                                                className="form-control select-search"
                                                                styles={select_style}
                                                                options={this.state.data_product}
                                                                onChange={(e) => {
                                                                    let stock_item_list = this.state.stock_item_list;
                                                                    stock_item_list[index].product_code = e;
                                                                    console.log(e)
                                                                    if (e) {
                                                                        stock_item_list[index].price_by_item = e.sell_price;
                                                                    } else {
                                                                        stock_item_list[index].price_by_item = 0;
                                                                    }
                                                                    stock_item_list[index].total_price_by_item = Number(stock_item_list[index].quantity) * Number(stock_item_list[index].price_by_item);

                                                                    this.setState({ stock_item_list: stock_item_list });
                                                                }}
                                                                value={item.product_code}
                                                                isClearable
                                                            ></Select>
                                                        </td>
                                                        <td className="text-center">
                                                            <input
                                                                className="form-control mb-2"
                                                                type="text"
                                                                placeholder=""
                                                                onChange={(e) => {
                                                                    if (!float(e.target.value)) {
                                                                        return
                                                                    }
                                                                    let stock_item_list = this.state.stock_item_list;
                                                                    stock_item_list[index].quantity = Number(e.target.value);
                                                                    stock_item_list[index].total_price_by_item = Number(stock_item_list[index].quantity) * Number(stock_item_list[index].price_by_item);
                                                                    this.setState({ stock_item_list: stock_item_list });
                                                                }}
                                                                value={item.quantity}
                                                            />
                                                        </td>
                                                        <td className="text-end">
                                                            <input
                                                                className="form-control mb-2 text-end"
                                                                type="text"
                                                                placeholder=""
                                                                onChange={(e) => {
                                                                    if (!float(e.target.value)) {
                                                                        return
                                                                    }
                                                                    let stock_item_list = this.state.stock_item_list;
                                                                    stock_item_list[index].price_by_item = Number(e.target.value);
                                                                    stock_item_list[index].total_price_by_item = Number(stock_item_list[index].quantity) * Number(stock_item_list[index].price_by_item);
                                                                    this.setState({ stock_item_list: stock_item_list });
                                                                }}
                                                                value={item.price_by_item}
                                                            />
                                                        </td>
                                                        <td className="text-end">{toFixed(item.total_price_by_item)}</td>
                                                        <td>
                                                            <div className="w-100 d-flex justify-content-center">
                                                                <div className="pointer wpx-30 hpx-30 rounded bg-danger-light mx-1 d-flex justify-content-center align-items-center"
                                                                    onClick={() => {
                                                                        Swal.fire({
                                                                            icon: "warning",
                                                                            title: "แจ้งเตือน",
                                                                            text: "ยืนยันการลบ \"" + item.product_code.label + "\" หรือไม่ \nหากลบแล้วจะไม่สามารถย้อนคืนข้อมูลที่ลบไปได้",
                                                                            confirmButtonText: "ตกลง",
                                                                            cancelButtonText: "ยกเลิก",
                                                                            showCancelButton: true,
                                                                        }).then((result) => {
                                                                            if (result.isConfirmed) {
                                                                                let stock_item_list = this.state.stock_item_list;
                                                                                stock_item_list.splice(index, 1);
                                                                                this.setState({ stock_item_list: stock_item_list });
                                                                            }
                                                                        });
                                                                    }}>
                                                                    <label className="pointer icon text-danger p-2">{"\uf2ed"}</label>
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                                <tr>
                                                    <td className="text-center">-</td>
                                                    <td>
                                                        <Select
                                                            className="form-control select-search"
                                                            styles={select_style}
                                                            options={this.state.data_product}
                                                            onChange={(e) => {
                                                                this.setState({ product_code: e });
                                                                if (e) {
                                                                    this.setState({ price_by_item: e.sell_price });
                                                                } else {
                                                                    this.setState({ price_by_item: "" });
                                                                }
                                                            }}
                                                            value={this.state.product_code}
                                                            isClearable
                                                        ></Select>
                                                    </td>
                                                    <td>
                                                        <input
                                                            className="form-control mb-2 text-end"
                                                            type="text"
                                                            placeholder=""
                                                            onChange={(e) => {
                                                                if (!float(e.target.value)) {
                                                                    return
                                                                }
                                                                this.setState({ quantity: Number(e.target.value) });
                                                            }}
                                                            value={this.state.quantity}
                                                        />
                                                    </td>
                                                    <td className="text-end">
                                                        <input
                                                            className="form-control mb-2 text-end"
                                                            type="text"
                                                            placeholder=""
                                                            onChange={(e) => {
                                                                if (!float(e.target.value)) {
                                                                    return
                                                                }
                                                                this.setState({ price_by_item: e.target.value });
                                                            }}
                                                            value={this.state.price_by_item}
                                                        />
                                                    </td>
                                                    <td className="text-end">
                                                        <div className="pt-2">
                                                            <label className="mb-2">{toFixed(this.state.quantity * this.state.price_by_item)}</label>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="w-100 d-flex justify-content-center">
                                                            <div className="wpx-30 hpx-30 rounded-circle bg-blue text-24 text-white d-flex justify-content-center align-items-center pointer"
                                                                onClick={() => {
                                                                    if (!this.state.product_code) {
                                                                        alert("warning", "แจ้งเตือน", "กรุณาเลือกสินค้า");
                                                                        return;
                                                                    } else if (!this.state.quantity) {
                                                                        alert("warning", "แจ้งเตือน", "กรุณากรอกจำนวน");
                                                                        return;
                                                                    } else if (!this.state.price_by_item) {
                                                                        alert("warning", "แจ้งเตือน", "กรุณากรอกราคาต่อหน่วย");
                                                                        return;
                                                                    }
                                                                    let stock_item_list = this.state.stock_item_list;
                                                                    stock_item_list.push({
                                                                        product_code: this.state.product_code,
                                                                        quantity: Number(this.state.quantity),
                                                                        price_by_item: Number(this.state.price_by_item),
                                                                        total_price_by_item: Number(this.state.quantity) * Number(this.state.price_by_item)
                                                                    })
                                                                    this.setState({
                                                                        stock_item_list: stock_item_list,
                                                                        product_code: "",
                                                                        quantity: "",
                                                                        price_by_item: "",
                                                                    })
                                                                }}>+</div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="p-3 pb-0">
                                        <div className="row">
                                            <div className="col-12 col-md-7 mb-2">
                                                <label className="mb-2">หมายเหตุ :</label>
                                                <textarea
                                                    className="form-control"
                                                    type="text"
                                                    placeholder=""
                                                    onChange={(e) => { this.setState({ remark: e.target.value }) }}
                                                    value={this.state.remark}
                                                    rows={5}
                                                />
                                            </div>
                                            <div className="col-12 col-md-5 mb-2">
                                                <div className="d-flex align-items-center justify-content-between mb-2">
                                                    <label>รวมเป็นเงิน</label>
                                                    <label>{toFixed(total(this.state.stock_item_list, "total_price_by_item"))}</label>
                                                </div>
                                                <div className="d-flex align-items-center justify-content-between mb-2">
                                                    <label className="me-2">ส่วนลด</label>
                                                    <input
                                                        className="form-control text-end"
                                                        type="text"
                                                        placeholder=""
                                                        onChange={(e) => {
                                                            if (!float(e.target.value)) {
                                                                return
                                                            }
                                                            this.setState({ discount: e.target.value })
                                                        }}
                                                        value={this.state.discount}
                                                    />
                                                </div>
                                                <div className="d-flex align-items-center justify-content-between mb-2">
                                                    <label>ราคาหลังหักส่วนลด</label>
                                                    <label>{toFixed(total(this.state.stock_item_list, "total_price_by_item") - Number(this.state.discount))}</label>
                                                </div>
                                                <div className="d-flex align-items-center justify-content-between mb-2">
                                                    <div className="d-flex align-items-center">
                                                        <Switch onChange={(e) => {
                                                            this.setState({
                                                                is_vat: e,
                                                            })
                                                        }} checked={this.state.is_vat} />
                                                        <label className="ms-2">ภาษีมูลค่าเพิ่ม 7%</label>
                                                    </div>
                                                    <label>{this.state.is_vat ? toFixed((total(this.state.stock_item_list, "total_price_by_item") - Number(this.state.discount)) * 0.07).replaceAll(",", "") : "0.00"}</label>
                                                </div>
                                                <div className="d-flex align-items-center justify-content-between mb-2">
                                                    <label>จำนวนเงินรวมทั้งสิ้น</label>
                                                    <label>{toFixed(total(this.state.stock_item_list, "total_price_by_item") - Number(this.state.discount) + Number(this.state.is_vat ? toFixed((total(this.state.stock_item_list, "total_price_by_item") - Number(this.state.discount)) * 0.07).replaceAll(",", "") : 0))}</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="w-100 p-3 d-flex align-items-center justify-content-end">
                                        {this.props.location.query.id && (
                                            <select
                                                className="form-control wpx-180 mx-1"
                                                type="text"
                                                placeholder=""
                                                onChange={(e) => { this.setState({ decision_status: e.target.value }) }}
                                                value={this.state.decision_status}
                                            >
                                                <option value="0">รออนุมัติ</option>
                                                <option value="1">อนุมัติ</option>
                                                <option value="2">ไม่อนุมัติ</option>
                                            </select>
                                        )}
                                        <button className="btn btn-outline-orange mx-1 px-5" onClick={() => { this.setState({ modal_sub_pay: true }) }}>
                                            ยกเลิก
                                        </button>
                                        <button className="btn btn-orange mx-1 px-5" onClick={() => {
                                            if (!this.state.company_id) {
                                                alert("warning", "แจ้งเตือน", "กรุณาเลือกบริษัท");
                                                return;
                                            } else if (this.state.stock_item_list.length === 0) {
                                                alert("warning", "แจ้งเตือน", "กรุณาเลือกสินค้า");
                                                return;
                                            }
                                            if (this.props.location.query.id) {
                                                this.Update()
                                            } else {
                                                this.Create()
                                            }
                                        }}>
                                            บันทึก
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        )
    }
}
